import Popover from '@material-ui/core/Popover';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { useSnackbar, ActionButton } from '@feedback/ui';
import { useMutationCallbacks } from '@feedback/relay';
import { EPreSignedUploadFileType, FILE_TYPES } from '@feedback/upload';

import ProfileImage from '../common/avatar/ProfileImage';

import routeTo from '../../router/utils/routeTo';
import UserImageDropzone from '../dashboard/subheader/components/UserImageDropzone';

import { removeToken } from '../../security/authentication';
import { CandidateProfileImageEditMutation } from '../dashboard/subheader/components/CandidateProfileImageEditMutation';
import { useUpload } from '../../mutations/useUpload';

const defaultErrorMessage = 'Não foi possível atualizar sua imagem';

const Content = styled.div`
  padding: 20px 25px;
  width: 250px;
`;

const Profile = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Icon = styled.div`
  position: relative;
  width: 80px;
`;

const IconLinkWrapper = styled.div`
  display: flex;
  background-color: rgba(255, 255, 255, 0.75);
  text-align: center;
  position: absolute;
  bottom: 0;
  right: 7px;
  height: 20px;
  width: 70px;
  line-height: 20px;
  justify-content: center;
`;

const Infos = styled.div`
  width: 175px;
`;

const Paragraph = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Name = styled(Paragraph)`
  margin: 0 0 4px;
  color: ${(props) => props.theme.darkGray};
`;

const Email = styled(Paragraph)`
  margin: 0 0 4px;
  font-size: 13px;
  color: #818284;
`;
const Job = styled(Paragraph)`
  margin: 0;
  font-size: 12px;
  font-weight: 300;
  text-decoration: italic;
  color: #a9a9a9;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  margin-top: 17px;
  margin-bottom: 10px;
  padding-top: 17px;
  border-top: 1px solid #dedede;
  justify-content: space-around;
`;

type Props = {};
const CandidatePopover = (props: Props) => {
  const { showSnackbar } = useSnackbar();
  const history = useHistory();

  const [uploadFile] = useUpload({
    fileType: EPreSignedUploadFileType.CANDIDATE_PROFILE_IMAGE,
    headerType: FILE_TYPES.IMAGE,
  });

  const [candidateProfileImageEdit] = useMutationCallbacks({
    name: 'CandidateProfileImageEdit',
    mutation: CandidateProfileImageEditMutation,
    success: 'Imagem atualizada com sucesso',
    error: defaultErrorMessage,
  });

  const setUploadedFileUrl = (fileUrl: string) => {
    const config = {
      variables: {
        input: {
          profileImage: fileUrl,
        },
      },
    };

    candidateProfileImageEdit(config);
  };

  const onLoad = async (droppedFiles) => {
    const { error, file } = await uploadFile({
      file: droppedFiles[0],
    });

    if (error || !file) {
      showSnackbar({ message: defaultErrorMessage });
      return;
    }

    setUploadedFileUrl(file.url, file.fields);
  };

  const handleLogout = async () => {
    await removeToken();
    return history.push(routeTo('public.home'));
  };

  const { open, anchorEl, close, profileImage, me } = props;

  const id = open ? 'simple-popover' : undefined;

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      targetOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      onClose={close}
    >
      <Content>
        <Profile>
          <Icon>
            <ProfileImage size={50} profileImage={profileImage} />
            <IconLinkWrapper>
              <UserImageDropzone onDropAccepted={onLoad} />
            </IconLinkWrapper>
          </Icon>

          <Infos>
            <Name>{me.name}</Name>
            <Email>{me.email}</Email>
            <Job>{me.jobTitle}</Job>
          </Infos>
        </Profile>
        <ButtonsWrapper>
          <ActionButton
            color='primary'
            onClick={() => history.push(routeTo('dashboard.account'))}
          >
            Minha Conta
          </ActionButton>
          <ActionButton onClick={handleLogout}>Sair</ActionButton>
        </ButtonsWrapper>
      </Content>
    </Popover>
  );
};

export default CandidatePopover;
